import axios from 'axios';
import { ISubdivisionsShortCollection, IUserShortCollection } from 'common/models';
import {
  IInventoryCollection,
  IInventoryDetailed,
  IInventoryListPayload,
  IInventoryListSubdivisionsParams,
  IInventoryListUsersParams,
  IInventoryAssigneesParams,
  IInventoryAssigneeCollection,
  ICreateInventoryAssigneePayload,
  IInventoryAssignee,
  IAddInventoryAssigneePayload,
  IRemoveInventoryAssigneePayload,
  ICreateInventoryPayload,
  IInventory,
  IInventoryPendingAssigneeCollection,
  IInventorySendDiffPayload,
  IInventorySentResult,
} from 'entities/Inventory/Inventory.models';

const basePath = 'inventory';

export const inventoryTransport = {
  get: (payload: IInventoryListPayload): Promise<IInventoryCollection> => axios.post(`${basePath}/list`, payload),
  getById: (id: number): Promise<IInventoryDetailed> => axios.get(`${basePath}/${id}`),
  create: (payload: ICreateInventoryPayload): Promise<IInventory> => axios.post(`${basePath}`, payload),
  getSubdivisions: (params: IInventoryListSubdivisionsParams): Promise<ISubdivisionsShortCollection> =>
    axios.get(`${basePath}/subdivisions`, { params }),
  getUsers: (params: IInventoryListUsersParams): Promise<IUserShortCollection> => axios.get(`${basePath}/users`, { params }),
  getAssignees: (params: IInventoryAssigneesParams): Promise<IInventoryAssigneeCollection> =>
    axios.get(`${basePath}/assignee`, { params }),
  createAssignee: (payload: ICreateInventoryAssigneePayload): Promise<IInventoryAssignee> =>
    axios.post(`${basePath}/assignee`, payload),
  deleteAssignee: (id: number): Promise<IInventoryAssignee> => axios.delete(`${basePath}/assignee/${id}`),
  addAssignee: (payload: IAddInventoryAssigneePayload): Promise<IInventoryDetailed> =>
    axios.post(`${basePath}/assignee/add`, payload),
  removeAssignee: (payload: IRemoveInventoryAssigneePayload): Promise<IInventoryDetailed> =>
    axios.post(`${basePath}/assignee/remove`, payload),
  getPendingAssignees: (): Promise<IInventoryPendingAssigneeCollection> => axios.get(`${basePath}/assignee/pending`),
  sendInventoryDiff: (payload: IInventorySendDiffPayload): Promise<IInventorySentResult> =>
    axios.post(`${basePath}/assignee/send`, payload),
};
